import * as React from 'react';

export function getLabel(label?: React.ReactElement | string): React.ReactNode {
	if (!label) return null;
	if (typeof label === 'string') return <span className="field-name">{label}</span>;

	return label;
}
